import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

import { useTranslation } from 'react-i18next';
import iHiBlinds from '../assets/img/icon-hi-blinds.jpg';
import iHechoAMano from '../assets/img/hecho-a-mano-logo.png';
import { FaLink } from 'react-icons/fa';

export default function Portafolio() {
  const isMobile = window.innerWidth <= 1024;
  const { t } = useTranslation();
const projects = [
    {
      title: t('portafolio.proyectos.hiBlinds.titulo'),
      description: t('portafolio.proyectos.hiBlinds.descripcion'),
      bullets: t('portafolio.proyectos.hiBlinds.bullets', { returnObjects: true }),
      link: 'https://hiblindsmx.com',
      image: iHiBlinds
    },
    {
      title: t('portafolio.proyectos.hiBlindsAgs.titulo'),
      description: t('portafolio.proyectos.hiBlindsAgs.descripcion'),
      bullets: t('portafolio.proyectos.hiBlindsAgs.bullets', { returnObjects: true }),
      link: 'https://hiblindsags.com',
      image: iHiBlinds
    },
    {
      title: t('portafolio.proyectos.hechoAMano.titulo'),
      description: t('portafolio.proyectos.hechoAMano.descripcion'),
      bullets: t('portafolio.proyectos.hechoAMano.bullets', { returnObjects: true }),
      link: 'https://hechoamanomx.com',
      image: iHechoAMano
    }
  ];


  return (
    <Section id="portafolio">
      <Heading>Portafolio</Heading>
      <ResponsiveWrapper>
        <MobileWrapper isMobile={isMobile}>
          {isMobile && (
            <Swiper
              modules={[Autoplay]}
              spaceBetween={20}
              slidesPerView={1.2}
              centeredSlides={true}
              loop={true}
              autoplay={{ delay: 4000 }}
            >
              {projects.map(({ title, description, bullets, link, image }, i) => (
                <SwiperSlide key={i}>
                  <Card
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: i * 0.2 }}
                  >
                    <Preview src={image} alt={`Vista previa ${title}`} />
                    <Title>{title}</Title>
                    <Content>
                      <Description>{description}</Description>
                      <br />
                      <ul>
                        {bullets.map((text, i) => (
                          <li key={i}>{text}</li>
                        ))}
                      </ul>
                    </Content>
                    <motion.a
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.8 }}
                      href={link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FaLink /> {t('portafolio.verPagina')}
                    </motion.a>
                  </Card>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </MobileWrapper>
        {!isMobile && (
          <Grid>
            {projects.map(({ title, description, bullets, link, image }, i) => (
              <Card
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: i * 0.2 }}
              >
                <Preview src={image} alt={`Vista previa ${title}`} />
                <Title>{title}</Title>
                <Content>
                  <Description>{description}</Description>
                  <br />
                  <ul>
                    {bullets.map((text, i) => (
                      <li key={i}>{text}</li>
                    ))}
                  </ul>
                </Content>
                <motion.a
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.8 }}
                  href={link}
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaLink /> {t('portafolio.verPagina')}
                </motion.a>
              </Card>
            ))}
          </Grid>
        )}
      </ResponsiveWrapper>
    </Section>
  );
}


const Section = styled.section`
  padding: 1.5rem;
  background-color: #0D0D0D;
  max-width: 1300px;
  margin: 0 auto;
`;

const Heading = styled.h2`
  font-size: 1.875rem;
  font-weight: 600;
  color: #FF4C4C;
  margin-bottom: 1.5rem;
  text-align: center;
`;

const Preview = styled.img`
  width: 100%;
  height: auto;
  max-width: 200px;
  max-height: 200px;
  object-fit: contain;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
`;

const Card = styled(motion.div)`
  background-color: #1E1E1E;
  padding: 1rem;
  border-radius: 0.75rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: background .4s, height .4s, border 1s;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 470px;
  margin: 0 auto;
  border: 2px solid transparent;

  a {
    margin-top: 1rem;
    display: inline-block;
    background-color: #FF4C4C;
    color: #fff;
    width: 60%;
    padding: 12px 10px;
    border-radius: 10px;
    text-decoration: none;
    transition: background 0.3s;
    text-align: center;
  }

  @media(min-width: 1024px) {
    cursor: pointer;
    &:hover {
      background-color: rgb(15, 15, 15);
      border: 2px solid #ff0f0f;
    }
    &:hover > p {
      height: 90%;
    }
    &:hover > h3 {
      color: #fff;
    }
    &:hover > a {
      background-color: #ff0f0f;
    }
  }
`;

const Title = styled.h2`
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #FF4C4C;
  transition: color .4s;
`;

const Content = styled.div`
  text-align: center;
  ul {
    list-style: none;
    color: #CCCCCC;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 20px;
    margin: 10px auto;
    padding: 0;
  }
`;

const Description = styled.h3`
  font-weight: 700;
  color: #CCCCCC;
  text-align: center;
  transition: background .4s, height .4s;
`;

const ResponsiveWrapper = styled.div`
  width: 100%;
`;

const MobileWrapper = styled.div`
  display: ${props => (props.isMobile ? 'block' : 'none')};
`;